import React from "react";
import Chat from "./Chat";
import "./App.css";

function App() {
  return (
    <div className="app">
      <header className="header">
        <h1>🏥 MedBot - Medical Assistant</h1>
        <p>Your AI-powered medical consultation assistant</p>
      </header>
      <main className="main-content">
        <Chat />
      </main>
    </div>
  );
}

export default App;
